import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgUsersFill = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 17"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M7.9 1.825c1.1 1.1 1.1 2.8 0 3.9s-2.8 1.1-3.9 0-1-2.8.1-3.9 2.8-1.1 3.8 0"
        clipRule="evenodd"
      />
      <path d="M3.7 1.169c1.375-1.246 3.458-1.245 4.73.126l.127.133C9.822 2.823 9.78 4.906 8.43 6.255c-1.393 1.393-3.568 1.393-4.96 0-1.428-1.428-1.257-3.604.1-4.96zm3.645 1.16C6.7 1.62 5.6 1.541 4.79 2.211l-.159.144c-.843.844-.872 2.067-.1 2.84.807.806 2.032.806 2.84 0 .756-.757.803-1.88.141-2.683l-.141-.157z" />
      <path
        fillRule="evenodd"
        d="M17.9 1.825c1.1 1.1 1.1 2.8 0 3.9s-2.8 1.1-3.9 0-1.1-2.8 0-3.9 2.9-1.1 3.9 0"
        clipRule="evenodd"
      />
      <path d="M13.602 1.17c1.389-1.254 3.583-1.246 4.853.15 1.367 1.394 1.36 3.55-.025 4.935-1.393 1.393-3.567 1.393-4.96 0-1.393-1.393-1.393-3.567 0-4.96zm3.743 1.16c-.646-.711-1.833-.789-2.655-.119l-.16.145c-.807.807-.807 2.031 0 2.838.807.808 2.032.808 2.84 0 .756-.756.803-1.88.142-2.682l-.143-.156z" />
      <path
        fillRule="evenodd"
        d="M21 15.025c0-2.8-2.2-5-5-5s-5 2.2-5 5c0-2.8-2.2-5-5-5s-5 2.2-5 5"
        clipRule="evenodd"
      />
      <path d="M20.25 15.025c0-2.386-1.864-4.25-4.25-4.25-2.311 0-4.133 1.75-4.244 4.028l-.006.222-.004.077a.75.75 0 0 1-1.496-.077c0-2.386-1.864-4.25-4.25-4.25s-4.25 1.864-4.25 4.25a.75.75 0 0 1-1.5 0c0-3.214 2.536-5.75 5.75-5.75 2.163 0 4.018 1.15 5 2.88.982-1.73 2.837-2.88 5-2.88 3.214 0 5.75 2.536 5.75 5.75a.75.75 0 0 1-1.5 0" />
      <path d="M0 16.025a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2z" />
    </svg>
  );
};
export default SvgUsersFill;
